<div class="container">
    <div *ngIf="docs$ | async as documents" class="container__item-list">
        <div *ngFor="let doc of documents" class="container__item-list__item">
            <ng-container *ngIf="doc.id != null">
                <div class="doc-container">
                    <span class="ham-icon">
                        <i class="file-icon" fileTypeImage [fileName]="doc.name"> </i>
                    </span>
                    <div>
                        <span>{{ doc.name }}</span>
                        <div class="doc-details">
                            {{ doc.size }} MB | {{ 'aumico_reports_fcp_uploaded' | i18next }}:&nbsp;
                            {{ doc.createdAt | timeAgo }}
                            <span class="uploaded-by">
                                {{ 'aumico_reports_fcp_file_uploaded_by' | i18next }}
                                {{ doc.uploadedByName }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="action-icons">
                    <span class="ham-icon" (click)="downloadDocument(doc)">
                        <i class="download-icon"></i>
                    </span>
                    <span
                        *ngIf="!lastYear"
                        hamIconShapes
                        icon="assets/hamIcons/minus.svg"
                        variant="gray"
                        size="xs"
                        type="circle"
                        (click)="onDocumentDeleted(doc)"
                    >
                    </span>
                </div>
            </ng-container>
        </div>
    </div>

    <div *ngFor="let doc of documentsInProgressUpload" class="container__item-list__item">
        <div class="uploading-file">{{ 'aumico_reports_fcp_uploading' | i18next }} {{ doc }}</div>
    </div>
    <div class="file-upload" (drop)="onDrop($event)" (dragover)="onDragOver($event)" *ngIf="!lastYear">
        <input
            #fileInput
            type="file"
            (change)="onFileUploadedChanged($event.target.files); resetFiles($event)"
            hidden
            [accept]="acceptedExtensions"
        />
        <span class="ham-icon"> <i class="upload-icon"></i></span>

        <p>{{ 'aumico_reports_drag_files' | i18next }}</p>
        <a class="link" (click)="fileInput.click()">{{ 'aumico_reports_browse_files' | i18next }}</a>

        <span class="extension-error" *ngIf="fileExtensionError"
            >{{ 'aumico_core_file_upload_extension_error' | i18next }}
        </span>
    </div>
</div>
